import { render, staticRenderFns } from "./RequiredManageField.vue?vue&type=template&id=c3e6cf40&scoped=true"
import script from "./RequiredManageField.vue?vue&type=script&lang=js"
export * from "./RequiredManageField.vue?vue&type=script&lang=js"
import style0 from "./RequiredManageField.vue?vue&type=style&index=0&id=c3e6cf40&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e6cf40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3e6cf40')) {
      api.createRecord('c3e6cf40', component.options)
    } else {
      api.reload('c3e6cf40', component.options)
    }
    module.hot.accept("./RequiredManageField.vue?vue&type=template&id=c3e6cf40&scoped=true", function () {
      api.rerender('c3e6cf40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/requiredManage/RequiredManageField.vue"
export default component.exports